import Gallery from "../classes/Gallery";

$(document).ready(function () {
    $('[gallery]').each(function () {
        this.id = this.id === '' ? Math.floor(Math.random() * 100000) : this.id;
        Gallery.get('#' + this.id);
    });
});